import   React,{ Component } from 'react'
import __ from 'lodash';
import {connect} from 'react-redux';
import accountManagement from '../../../../apis/accountManagement';
import { CONFIG } from '../../../../config';
import { Redirect } from 'react-router-dom'
import {cekCookies} from '../../../../actions';
import FormEdit from './FormEdit';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import Guru from '../../../../entity/Guru';
import GuruClass from './Guru';


const $ = require('jquery')
$.Datatable = require('datatables.net')

class ListTabelGuru extends Component {
    constructor(props){
        super(props);
        this.state={
            dataGuru:{},
            isSearch: false,
            usernameGuru: null,
            namaGuru: null,
            emailGuru: null,
            handphoneGuru: null,
            emailGuru: null,
            idGuru: null,
            statusGuru: null
        }
    }

    renderListGuru(){
        if(!__.isEmpty(this.props.dataGuru)){
            return this.props.dataGuru.map((g,i) => {
                return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.usernameGuru}</td>
                        <td>{g.namaGuru}</td>
                        <td>{g.handphoneGuru}</td>
                        <td>{g.emailGuru}</td>
                        <td>{g.statusGuru}</td>
                        <td>
                            <select className="form-control" onChange={this.onDropdownChange}>
                                <option value="pilih aksi" disabled selected>Pilih Menu</option>
                                <option value={"reset-"+g.idGuru} >Reset Password</option>
                                {/* <option value={"edit-"+g.idGuru} >Edit</option> */}
                                <option value={"hapus-"+g.idGuru} >Hapus</option>
                                {this.onOff(g.statusGuru, g.idGuru)}
                            </select>
                        </td>
                        <td>
                            <button className="btn btn-outline-primary" data-toggle="modal" data-target="#editGuru" data-backdrop="static" data-keyboard="false" title="edit" onClick={this.fetchGuruById.bind(this, g.idGuru)}>
                                <li className="fa fa-pencil"></li>
                            </button>
                        </td>
                    </tr>
                )
            })
        }else{
            return (
                <tr>
                    <td colSpan="8">Tidak Ada Guru</td>
                </tr>
            )
        }         
    }

    reset = async (idGuru) =>{
        console.log(idGuru);
    }

    onOff = (status, idGuru) =>{
        if(status == "AKTIF"){
            return(
                <option value={"isOn-"+idGuru} >Non Aktifkan</option>
            )
        }else{
            return(
                <option value={"isOff-"+idGuru} >Aktifkan</option>
            )
        }
    }

    onDropdownChange = (event) => {
        if(event.target.value === ""){
            this.props.onChange(null);
        }else{
            this.props.onChange(event.target.value);
        }
    }

    fetchGuruById = async (idGuru)=>{
        this.setState({isSearch:true})
        const fetchGuru = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_GURU_BY_ID,
            {
                ...Guru, ['idGuru']:idGuru, ['idSekolah']:this.props.account.idSekolah
            })
        .catch(function(error){
        })
        
        console.log(fetchGuru.data.data);
        this.setState({usernameGuru:fetchGuru.data.data.usernameGuru})
        this.setState({namaGuru:fetchGuru.data.data.namaGuru})
        this.setState({emailGuru:fetchGuru.data.data.emailGuru})
        this.setState({handphoneGuru:fetchGuru.data.data.handphoneGuru})
        this.setState({emailGuru:fetchGuru.data.data.emailGuru})
        this.setState({idGuru:fetchGuru.data.data.idGuru})
        if(fetchGuru.data.data.statusGuru == "-"){
            this.setState({statusGuru:'-'})
        }else if(fetchGuru.data.data.statusGuru == "AKTIF"){
            this.setState({statusGuru:0})
        }else{
            this.setState({statusGuru:1})
        }  
        this.setState({isSearch:false})
        
    }

    

    // HANDLE CHANGE INPUT
    namaGuruOnChange = (event) =>{
        this.setState({namaGuru: event.target.value})
    }
    usernameGuruOnChange = (event) => {
        this.setState({usernameGuru: event.target.value})
    }
    emailGuruOnChange = (event) => {
        this.setState({emailGuru: event.target.value})
    }
    telponGuruOnChange = (event) => {
        this.setState({handphoneGuru: event.target.value})
    }
    passwordGuruOnChange = (event) => {
        this.setState({passwordGuru: event.target.value})
    }
    statusGuruOnChange = (event) => {
        this.setState({statusGuru: event.target.value})
    }

    handleEdit = async (event)=> {
        event.preventDefault();
        this.setState({isFetching: true});
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPDATE_GURU , 
            {...Guru, 
                ["idSekolah"]: this.props.account.idSekolah,
                ["idGuru"]: this.state.idGuru,
                ["namaGuru"]: this.state.namaGuru,
                ["usernameGuru"]: this.state.usernameGuru,
                ["emailGuru"]: this.state.emailGuru,
                ["handphoneGuru"]: this.state.handphoneGuru,
                ["passwordGuru"]: this.state.passwordGuru,
                ["statusGuru"]: this.state.statusGuru,
            }).catch(function(error){})

        this.setState({isFetching: false});

        console.log(response);

        if(response.data.data.result) {
            // alert(response.data.data.message)
            window.location.reload();            
        }
        else {
            alert(response.data.data.message)
        }
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
        
    showModal(){
        return(
            <div className="modal fade" id="editGuru">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content"> 
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Guru</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        
                        <form id="form-tambah" onSubmit={this.handleEdit}>
                            <div className="modal-body">
                                <div className="row">
                                {this.loading()}
                                    <input type="hidden" value={this.state.idGuru} />
                                    <div className="col-md-4">
                                        <label>Nama Guru</label>
                                        <input type="text" className="form-control" value={this.state.namaGuru} onChange={this.namaGuruOnChange} placeholder="Nama Guru" required autoComplete="off"/>
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Username Guru</label>
                                       <input type="text" className="form-control" value={this.state.usernameGuru} onChange={this.usernameGuruOnChange} placeholder="Username Guru" disabled autoComplete="off"/>
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Email Guru</label>                                       
                                        <input type="email" className="form-control" value={this.state.emailGuru} onChange={this.emailGuruOnChange} placeholder="Email Guru" required autoComplete="off"/>
                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>No Telpon</label>                                         
                                        <input type="number" className="form-control" value={this.state.handphoneGuru} onChange={this.telponGuruOnChange} placeholder="Nomor Guru" required autoComplete="off" minLength="10"/>
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Password</label>                                          
                                        <input type="password" className="form-control" value={this.state.passwordGuru} onChange={this.passwordGuruOnChange}  placeholder="Password Guru" min="4"/>
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Status Guru</label>
                                        <select className="form-control" value={this.state.statusGuru} onChange={this.statusGuruOnChange}  required>
                                            <option value="-" disabled>Belum Ada</option>
                                            <option value="0">Aktif</option>
                                            <option value="1">Tidak Aktif</option>
                                        </select>
                                       
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger float-left" data-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Simpan</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div> 
        );
    }

    

    render() {
        return (
            <div className="row">
            <LoaderModal isFetching={this.state.isFetching} />
                <div className="col-md-12">
                    <table className="table table-striped" id="myTable">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Username</th>
                                <th>Nama</th>
                                <th>No Telp</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Reset</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderListGuru()}
                        </tbody>
                    </table>
                    {/* <FormEdit dataGuru={this.state.dataGuru}/> */}
                    {this.showModal()}
                </div>
            </div>
        )
        
    }

}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps)(ListTabelGuru);